import { Component, OnDestroy, HostListener } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LanguageInterface } from '@mzima-client/sdk';
import { LanguageService } from '../../../core/services';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnDestroy {
  languages$: Observable<LanguageInterface[]>;
  selectedLanguage$: Observable<string>;
  isDropdownOpen = false;
  private subscription: Subscription = new Subscription();

  constructor(private languageService: LanguageService) {
    this.languages$ = this.languageService.languages$;
    this.selectedLanguage$ = this.languageService.selectedLanguage$;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectLanguage(code: string) {
    this.languageService.setSelectedLanguage(code);
    this.isDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;
    const isInsideDropdown = clickedElement.closest('.language-selector');

    if (!isInsideDropdown && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }
}
